import { NavLink, Outlet, useLocation } from "react-router-dom";

// Admin-side sub-nav for the "My Projects" feature.
// Mirrors the principal-side PortfolioShell layout but lives inside the
// admin Dashboard (so the firm-wide nav stays visible above).
const TABS = [
  { to: "",          label: "Portfolio", end: true },
  { to: "summary",   label: "Summary",   end: false },
  { to: "add",       label: "Add",       end: false },
];

export default function MyProjectsLayout() {
  const loc = useLocation();
  // Hide the sub-nav when on the edit screen so the form has full width.
  const onEdit = /\/my-projects\/edit\//.test(loc.pathname);

  return (
    <div className="space-y-6" data-testid="my-projects-layout">
      {!onEdit && (
        <div className="flex items-center gap-1 border-b border-[var(--rule)] pb-2 -mt-2" data-testid="my-projects-tabs">
          {TABS.map((t) => (
            <NavLink
              key={t.label}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                `px-3 py-1.5 text-xs font-display tracked-tight uppercase ` +
                (isActive
                  ? "text-[var(--ink)] border-b-2 border-[var(--ink)] -mb-[9px]"
                  : "text-[var(--soft-fg)] hover:text-[var(--ink)]")
              }
              data-testid={`my-projects-tab-${(t.label || "portfolio").toLowerCase()}`}
            >
              {t.label}
            </NavLink>
          ))}
        </div>
      )}
      <Outlet />
    </div>
  );
}
